import { Typography } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Form, Tabs } from '~/components';
import WizardForm from '~/components/WizardForm';
import { useGetApplication } from '~/controllers/wizard';
import { SignatureIcon } from '~/img';
import AuthorizedRepresentativeTable from './AuthorizedRepresentativeTable';

const AuthorizedRepresentativeView: React.FC = () => {
  const { t } = useTranslation('fillApplication');
  const [form] = Form.useForm();
  const globeState = useSelector((state: any) => state?.state);
  const applicationQuery = useGetApplication();
  const { commonFormErrors } = globeState;

  const authorizedRepresentativeHasError = useMemo(() => {
    if (!commonFormErrors) return false;
    return !!commonFormErrors['/wizard/application/authorizedRepresentative'];
  }, [commonFormErrors]);

  if (!applicationQuery.data) {
    return null;
  }

  return (
    <WizardForm
      form={form}
      stepKey="authorizedRepresentative"
      handleDraftDataBeforeSave={(v) => v}
      setInitialValues={(v: any) => ({
        ...v,
        authorizedRepresentative: Array.isArray(v?.authorizedRepresentative) ? v.authorizedRepresentative : [],
      })}
    >
      <Typography.Title level={4}>{t('Add Authorized Representative').toUpperCase()}</Typography.Title>
      <Typography.Paragraph>{t('Please provide details of the Authorized Representative')}</Typography.Paragraph>

      <StyledTabs defaultActiveKey="first" sticky centered>
        <StyledTabs.TabPane
          tab={
            <span data-error={authorizedRepresentativeHasError}>
              <SignatureIcon />
              {t('Authorized Representative')}
            </span>
          }
          key="first"
        >
          <div className="AuthorizedRepresentativeTable-TabContent">
            <Form.Item name={['authorizedRepresentative']} noStyle>
              <AuthorizedRepresentativeTable />
            </Form.Item>
          </div>
        </StyledTabs.TabPane>
      </StyledTabs>
    </WizardForm>
  );
};

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 24px;
    z-index: 3;
  }
  .ant-table-empty {
    tbody {
      display: none;
    }
  }
  .AuthorizedRepresentativeTable-TabContent {
    max-width: calc(100vw - ${16 * 2 + 8 * 2}px);
  }
`;

export default AuthorizedRepresentativeView;
